'use client';

import dynamic from 'next/dynamic';

export const EnvelopeLayers = dynamic(
  () => import('./EnvelopeLayers')
);
